/** Narrows away `null` and `undefined` — useful as an `Array#filter` predicate. */
export function isDefined(value) {
    return value !== null && value !== undefined;
}
/** Compile-time exhaustiveness check; throws if a case is ever missed at runtime. */
export function assertNever(value) {
    throw new Error(`Unexpected value: ${JSON.stringify(value)}`);
}
//# sourceMappingURL=guards.js.map